import BangladeshImg from '../../../assets/images/bangladesh.jpg';
import JapanImg from '../../../assets/images/japan.jpg';
import CanadaImg from '../../../assets/images/canada.jpg';
import IndiaImg from '../../../assets/images/taj-mahal.jpg';

const imageCardData = [
    {
        img: BangladeshImg,
        access: 'Open',
        title: 'Bangladesh',
        description: 'Lorem ipsum dolor sit amet',
        howImportant: 'Important'
    },
    {
        img: JapanImg,
        access: 'Open',
        title: 'Japan',
        description: 'Lorem ipsum dolor sit amet',
        howImportant: 'Important'
    },
    {
        img: CanadaImg,
        access: 'Close',
        title: 'Canada',
        description: 'Lorem ipsum dolor sit amet',
        howImportant: 'Important'
    },
    {
        img: IndiaImg,
        access: 'Open',
        title: 'India',
        description: 'Lorem ipsum dolor sit amet',
        howImportant: 'Important'
    },

];

export default imageCardData;
